import _ from 'lodash';
import API from '@/api';
import * as types from '@/store/mutationTypes';
import { mapGetters } from 'vuex';

import { txStatus } from '@/types';

import * as Checks from '@/store/permissions';
import quickbooksMixin from './quickbooksMixin';

export default {
  data: () => ({
    updatingTransaction: false,
  }),
  mixins: [
    quickbooksMixin,
  ],
  computed: {
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    ...mapGetters('loadTransactions', {
      loadingTransactions: 'loadingTransactions',
      transactionsTime: 'timestamp',
      billTransactions: 'billTransactions',
      invoiceTransactions: 'invoiceTransactions',
      transactionsCompanyId: 'companyId',
    }),
  },
  filters: {
    formatTimeStamp(momentDate) {
      return momentDate.format('HH:mm A MMM DD');
    },
  },
  methods: {
    ...mapGetters('profiles', [
      'findCompanyAccount',
    ]),
    canAccountViewCompanyLoadSettlements(companyId) {
      const companyAccount = this.findCompanyAccount()(companyId);
      return Checks.canAccountViewCompanyLoadSettlements(companyAccount);
    },
    loadCompanyTransactions(companyId) {
      return this.$store.dispatch('loadTransactions/getLoadTransactions', companyId);
    },
    async refreshTransaction(txn) {
      try {
        this.updatingTransaction = true;
        const apiResponse = await API.settlements.getTransaction(txn.id);
        this.$store.dispatch('loadTransactions/updateTransaction', apiResponse.data);
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.updatingTransaction = false;
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    transactionCustomer(transaction) {
      let customer;
      // customer will always be present; companyId might not
      const customerId = transaction.customer.companyId;
      if (customerId) {
        customer = this.transactionParticipantsByCompanyId(transaction)[customerId];
      }

      if (!customer) {
        customer = {
          name: transaction.customer.companyName,
        };
      }

      return customer;
    },
    transactionVendor(transaction) {
      const vendorId = transaction.vendor.companyId;
      if (vendorId) {
        return this.transactionParticipantsByCompanyId(transaction)[vendorId];
      }

      return {
        name: transaction.vendor.companyName,
      };
    },
    transactionLoadOwner(transaction) {
      return this.loadGroupOwner(transaction.load.tacticalInfo);
    },
    transactionLoadCustomer(transaction) {
      return this.loadGroupSponsor(transaction.load.tacticalInfo);
    },
    transactionTruckingCompany(transaction) {
      return _.get(transaction, 'load.tacticalInfo.truckingCompany');
    },
    transactionHaulingCompany(transaction) {
      const vendor = _.get(transaction, 'load.tacticalInfo.assignedVendor');
      return vendor || this.transactionTruckingCompany(transaction);
    },
    transactionTruckingCompanyIsOwner(transaction) {
      const carrierId = _.get(this.transactionTruckingCompany(transaction), 'id');
      const ownerId = this.loadGroupOwner(transaction.load.tacticalInfo).id;
      return carrierId === ownerId;
    },
    transactionLoadIsDirectDispatched(transaction) {
      return this.transactionTruckingCompanyIsOwner(transaction);
    },
    transactionShipper(transaction) {
      return {
        company: this.loadGroupShipper(transaction.load.tacticalInfo),
        location: this.loadGroupShippingLocation(transaction.load.tacticalInfo),
      };
    },
    transactionReceiver(transaction) {
      return {
        company: this.loadGroupReceiver(transaction.load.tacticalInfo),
        location: this.loadGroupReceivingLocation(transaction.load.tacticalInfo),
      };
    },
    transactionParticipantsByCompanyId(transaction) {
      const participants = this.loadGroupParticipantsByCompanyId(transaction.load.tacticalInfo);
      const truckingCompany = this.transactionTruckingCompany(transaction);
      if (truckingCompany) {
        participants[truckingCompany.id] = truckingCompany;
      }

      return participants;
    },
    transactionDriver(transaction) {
      return _.get(transaction, 'load.tacticalInfo.driverInfo', null);
    },
    transactionDescription(transaction) {
      return _.get(transaction, 'description');
    },
    transactionInvoice(transaction) {
      return _.get(transaction, 'invoice', {}) || {};
    },
    transactionPayment(transaction) {
      return _.get(transaction, 'payment', {}) || {};
    },
    transactionReceivedPayment(transaction) {
      return _.get(transaction, 'receivedPayment', {}) || {};
    },

    transactionQbCustomer(transaction, invoicingCompany) {
      let customers = [];
      if (this.shouldUseQuickbooks(invoicingCompany)) {
        customers = (this.customersStatus[invoicingCompany.id] || false) ? [] : this.quickbooksCustomers(invoicingCompany.id);
      }
      const customerId = parseInt(transaction.customer.companyId, 10);
      return _.find(customers, c => parseInt(c.ltnCompanyId, 10) === customerId);
    },
    transactionStatus(tx) {
      return _.get(tx, 'status');
    },
    isTransactionOpen(tx) {
      return this.transactionStatus(tx) === txStatus.OPEN;
    },
    isTransactionApproved(tx) {
      return this.bookedLoadStatus(tx) === txStatus.APPROVED;
    },
    isTransactionExported(tx) {
      return this.bookedLoadStatus(tx) === txStatus.EXPORTED;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/loadTransactionsMixin.js